<template>
  <v-container fluid :class="desktop ? 'pa-5 pl-10' : ''">
    <vue-headful title="Service (Admin)" description="Web-Service Config"/>
    <v-row v-if="isAuthorized" class="pt-5">
      <v-main>
        <router-view></router-view>
      </v-main>
    </v-row>
    <v-alert v-else type="error" class="mt-10">You lack permissions for this page</v-alert>
  </v-container>
</template>

<script>
import UserLib from "@/components/UserLib";

export default {
  name: 'Service',
  components: {},
  data() {
    return {}
  },
  mounted() {
    console.log("Service: this.$app.desktop = ", this.$app.desktop);
    if (this.$app.desktop) {
      this.$app.show_drawer = true;
    }
    this.$app.setIntern();
    this.$nextTick(this.check_session) // and if not, open user data form
  },
  methods: {
    check_session() {
      if (!this.$app.is_logged_in || !(this.$app.is_super_user || this.$app.is_admin)) {
        console.error("not logged in or not auth", "logged in: " + this.$app.is_logged_in, "su: " + this.$app.is_super_user, "admin: " + this.$app.is_admin);
        this.$router.replace("/")
      } else {
        this.$backend.check_session();
      }
    },
  },
  computed: {
    isAuthorized() {
      return this.su || this.admin;
    },
    su() {
      return this.$app.is_super_user;
    },
    admin() {
      return this.$app.is_admin;
    },
    desktop() {
      return this.$app.desktop;
    }
  },
  // watch: {
  //   is_logged_in(n, o) {
  //     console.log("is_logged_in: " + n);
  //     if (!n) {
  //       this.$router.go(-1000);
  //       this.$router.replace("/")
  //     }
  //   }
  // }
}
</script>
